import React from "react"
import Layout from "../components/layout"
import HeroAlquiler from "../components/heroAlquiler"
import Flota from "../components/alquilerBuses/flota"
import ServiciosEspecializados from "../components/alquilerBuses/serviciosEspecializados"
import Img from "../assets/images/alquilerbuses.webp"
export default function AlquilerDeBuses() {
  return (
    <>
      <Layout
        img={Img}
        title="Alquiler de Buses"
        description="Servicio de alquiler de buses de Intramet"
      >
        <HeroAlquiler
          img={Img}
          title="Alquiler de Buses para Transporte Personal"
          text="Movilidad segura, rápida y al mejor precio para el traslado de tus elementos."
        />
        <Flota />
        <ServiciosEspecializados />
      </Layout>
    </>
  )
}
